module.exports = __webpack_public_path__ + "img/240x240_bg_default@2x.c2775808.png";